import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	templateUrl: './details.component.html'
})
export class TemplateTagDetailsComponent extends InfoModalComponent {
	detailLoader: boolean = false;
	details;

	ok() {
		this.close();
	}
}
